import { METRICS_LIST, type MetricsList } from '@/features/locations/constants';
import type { ICapturedAadtExtracted, IProjectResults } from '@/types/api';

/**
 * Rebuild the metric selection that produced a location's results so a radius
 * re-compute requests the same set. Results carry the computed metric labels
 * (which match METRICS_LIST values); forecast, captured AADT, and the
 * highest performing competitor are separate and only present when they were
 * requested and produced.
 */
export function requestedMetricsFromResults(
  results: IProjectResults,
  capturedAadtData?: ICapturedAadtExtracted,
): MetricsList[] {
  const metrics = new Set<MetricsList>(results.metrics.map((m) => m.label as MetricsList));
  if (results.highest_performing_competitor) {
    metrics.add(METRICS_LIST.HIGHEST_PERFORMING_COMPETITOR);
  }
  if (results.forecast) {
    // Forecast requires captured AADT (the backend rejects forecast without it),
    // so pair them even if the separate captured-AADT query has not resolved.
    metrics.add(METRICS_LIST.FORECAST);
    metrics.add(METRICS_LIST.CAPTURED_AADT);
  } else if (capturedAadtData) {
    metrics.add(METRICS_LIST.CAPTURED_AADT);
  }
  return [...metrics];
}
